import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() text: string = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() delay: number = 200; // Delay em ms antes de mostrar
  @Input() zIndex: number = 1000;

  showTooltip: boolean = false;
  timeoutId: any;

  ngOnInit(): void {}

  onMouseEnter() {
    this.timeoutId = setTimeout(() => {
      this.showTooltip = true;
    }, this.delay);
  }

  onMouseLeave() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.showTooltip = false;
  }
}
